import { Grid, makeStyles } from '@material-ui/core';
import { useI18nFormat } from '@topconagriculture/language';
import { Text } from '@topconagriculture/react-components';
import { toCssValue } from '@topconagriculture/theme';
import * as React from 'react';
import { PlatformNotificationTypes } from '../../types';
import { useTranslation } from 'react-i18next';
import { Linkify } from '../Linkify';
import DOMPurify from 'dompurify';
import { markdownToHTML } from '../../utils/markdown';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: toCssValue([10, 25]),
        overflow: 'auto',
        flex: '3 0 0',
        '& img': {
            maxWidth: '100%',
        },
        '& ul': {
            marginLeft: 30,
        },
        '& ol': {
            marginLeft: 30,
        },
        '& .code': {
            padding: 10,
            background: theme.color.grey.light,
        },
        '& blockquote': {
            marginLeft: 20,
            color: 'rgba(101, 103, 107)',
            borderLeftColor: 'rgba(206, 208, 212)',
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
            paddingLeft: 16,
        },
        '& h1': {
            fontWeight: 200,
            fontSize: 24,
            color: '#333',
        },
        '& h2': {
            fontWeight: 200,
            fontSize: 20,
            color: '#333',
        },
        '& h3': {
            fontWeight: 200,
            fontSize: 18,
            color: '#333',
        },
        '& h4': {
            fontWeight: 200,
            fontSize: 16,
            color: '#333',
        },
        '& h5': {
            fontWeight: 200,
            fontSize: 15,
            color: '#333',
        },
        '& h6': {
            fontWeight: 200,
            fontSize: 14,
            color: '#333',
        },
    },
    content: {
        whiteSpace: 'pre-line',
    }
}));
const NotificationCard = ({ notification, userLocale }) => {
    var _a;
    const classes = useStyles();
    const { formatDateTime } = useI18nFormat();
    const { t } = useTranslation();
    if (!notification) {
        return React.createElement("div", { className: classes.root });
    }
    const content = (_a = notification.payload.content.find((cont) => cont.lang === userLocale)) === null || _a === void 0 ? void 0 : _a.description;
    return (React.createElement("div", { className: classes.root },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Text, { bold: true, size: 16, lineHeight: 1.2 }, t('common:platform_notifications.' + notification.type))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Text, { size: 12 }, formatDateTime(notification.notificationStartDate))),
            React.createElement(Grid, { item: true, xs: 12, className: classes.content },
                !!content && notification.type !== PlatformNotificationTypes.RELEASE_NOTE ? React.createElement(Linkify, null, content) : null,
                !!content && notification.type === PlatformNotificationTypes.RELEASE_NOTE ? React.createElement("span", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(markdownToHTML(content)) } }) : null))));
};
export default NotificationCard;
//# sourceMappingURL=NotificationCard.js.map